import {videoPlay} from '../features/video-play';
import {register} from '../vendor/theme-scripts/theme-sections';

register('image-with-text', videoPlay);
